import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Permission, SessionStore} from '../../store';
import {IMenuCategoryDisplay} from './interfaces/IMenuCategoryDisplay';
import type {TEmbedMode} from './constants/EmbedMode';

export interface IUIStoreState {
	showPushNotificationRequest: boolean;
	showPushNotificationDisabled: boolean;
	showGeolocationRequest: boolean;
	showGeolocationDisabled: boolean;
	showSidebar: boolean;
}

/**
 * This is used for things that we want to be able to toggle anywhere for UI compnents that live at
 * a high or global level.
 */
@Module({name: 'ui', namespaced: true})
class UIModule extends VuexModule implements IUIStoreState {
	hasConnection = true;
	embedMode: TEmbedMode = 'none'; // TODO: Using the constant here causes an error with Jest and item.service.test.ts
	showPushNotificationRequest = false;
	showPushNotificationDisabled = false;
	showGeolocationRequest = false;
	showGeolocationDisabled = false;
	/**
	 * indicates if the home page initial animation should play
	 *
	 * We only want to show the animation of the first load of the session.
	 */
	showHomeIntro = true;

	showSidebar = false;

	menuCategoryDisplay: IMenuCategoryDisplay | null = null;

	@Mutation
	public setHasConnection(hasConnection: boolean) {
		this.hasConnection = hasConnection;
	}

	@Mutation
	public setShowPushNotificationRequest(show: boolean) {
		if(show) {
			SessionStore.setRequested(Permission.PUSH_NOTIFICATIONS);
		}
		this.showPushNotificationRequest = show;
	}

	@Mutation
	public setShowPushNotificationDisabled(show: boolean) {
		if(show) {
			// If either of these are shown we don't want to auto-show again
			SessionStore.setRequested(Permission.PUSH_NOTIFICATIONS);
		}
		this.showPushNotificationDisabled = show;
	}

	@Mutation
	public setShowGeolocationRequest(show: boolean) {
		if(show) {
			SessionStore.setRequested(Permission.LOCATION);
		}
		this.showGeolocationRequest = show;
	}

	@Mutation
	public setShowGeolocationDisabled(show: boolean) {
		if(show) {
			// If either of these are shown we don't want to auto-show again
			SessionStore.setRequested(Permission.LOCATION);
		}
		this.showGeolocationDisabled = show;
	}

	@Mutation
	public setShowSidebar(show: boolean) {
		this.showSidebar = show;
	}

	@Mutation
	public setHomePagePlayed() {
		this.showHomeIntro = false;
	}

	@Mutation
	public setMenuCategoryDisplay(display: IMenuCategoryDisplay | null) {
		this.menuCategoryDisplay = display;
	}

	@Mutation
	public setEmbedMode(mode: TEmbedMode) {
		this.embedMode = mode;
	}
}


export {
	UIModule
};
